import '../assets/NcActionSeparator-CX3zFZuI.css';
import { n as t } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const n = {
  name: "NcActionSeparator"
};
var e = function() {
  var a = this, r = a._self._c;
  return r("li", { staticClass: "action action-separator action--disabled", attrs: { role: "separator" } });
}, o = [], s = /* @__PURE__ */ t(
  n,
  e,
  o,
  !1,
  null,
  "82b7f2ae",
  null,
  null
);
const l = s.exports;
export {
  l as default
};
